import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { CNMC, CNMCFilters } from '../types';

import { cnmcQueryKeys } from './query-keys';

export async function getCNMCs(
  params?: ParamsWithPagination<CNMCFilters>
): Promise<PaginatedResponse<CNMC>> {
  return mediaManagerClient.get('/api/v1/cnmcs', {
    params,
  });
}

type QueryFnType = typeof getCNMCs;

interface UseCNMCsParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<CNMCFilters>;
}

export function useCNMCs({ config, params }: UseCNMCsParams = {}) {
  return useQuery({
    ...config,
    queryKey: cnmcQueryKeys.list(params),
    queryFn: () => getCNMCs(params),
  });
}
